export class CreateWorkTypePricingError extends Error {

}
